import { State } from 'flow/types/State';
import { QueueKey } from 'flow/types/EntityKeys';

export const selectTicketCreationSetting = (state: State, key: QueueKey) =>
    state.tickets.getIn(['settings', 'perQueue', key, 'autoCreateTicket']);

export const selectCloseOnHangupSetting = (state: State, key: QueueKey) =>
    state.tickets.getIn(['settings', 'perQueue', key, 'closeOnHangUp']);

export const selectCloseOnMissedCallSetting = (state: State, key: QueueKey) =>
    state.tickets.getIn(['settings', 'perQueue', key, 'closeOnMissedCall']);
